/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.9.0 (NJsonSchema v10.6.8.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import { UserStore, LoadingSpinnerService } from "@/store";
import router, { ROUTES } from "@/router";
export default class ApiClientBase {
  protected transformOptions(options: RequestInit) {
    var token = UserStore.getJWT;
    var headers = options.headers as { [key: string]: string };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    return Promise.resolve(options);
  }

  protected async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => any,
    options: RequestInit
  ) {
    if (response.status === 401) {
      if (response.headers.get("refresh-token-expired")) {
        if (UserStore.refreshTokenMatches(options)) {
          return this.sessionExpired();
        }
      } else if (response.headers.get("token-expired")) {
        // Attempt to refresh token
        try {
          await UserStore.RefreshAuthToken();
          const transformedOptions_ = await this.transformOptions(options);
          const newResponse = await fetch(url, transformedOptions_);
          return processor(newResponse);
        } catch (e) {
          return this.sessionExpired();
        }
      } else {
        return this.sessionExpired();
      }
    } else {
      UserStore.RefreshSessionTimer();
      return processor(response);
    }
  }

  private sessionExpired() {
    return router.push({ name: ROUTES.sessionTimeout }).catch(err => {});
  }
}

export class AuthenticationApiClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:55195";
    }

    roles_Create(command: CreateRoleCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles_Create(_response), options_);
        });
    }

    protected processRoles_Create(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    roles_AddToRole(command: AddUserToRoleCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/adduser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles_AddToRole(_response), options_);
        });
    }

    protected processRoles_AddToRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    roles_ListAll(query: FindAllRolesQuery): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles_ListAll(_response), options_);
        });
    }

    protected processRoles_ListAll(response: Response): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }

    roles_UserRoles(query: FindUserRolesQuery): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/Roles/userroles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles_UserRoles(_response), options_);
        });
    }

    protected processRoles_UserRoles(response: Response): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }

    users_Authenticate(command: AuthenticateUserCommand): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_Authenticate(_response), options_);
        });
    }

    protected processUsers_Authenticate(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    users_Terms(command: ConfirmTermsAndServiceCommand): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users/confirmTerms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_Terms(_response), options_);
        });
    }
    protected processUsers_Terms(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    users_RecoverPassword(command: ChangeUserPasswordCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/recoverpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_RecoverPassword(_response), options_);
        });
    }

    protected processUsers_RecoverPassword(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    users_IsEmailConfirmed(userId: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/emailConfirmed?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_IsEmailConfirmed(_response), options_);
        });
    }

    protected processUsers_IsEmailConfirmed(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    users_ConfirmEmail(userId: string | null | undefined, token: string | null | undefined): Promise<EmailConfirmationResultDto> {
        let url_ = this.baseUrl + "/api/Users/confirmEmail?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_ConfirmEmail(_response), options_);
        });
    }

    protected processUsers_ConfirmEmail(response: Response): Promise<EmailConfirmationResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailConfirmationResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailConfirmationResultDto>(null as any);
    }

    users_RequestPasswordChange(command: RequestPasswordChangeCommand): Promise<RequestPasswordResultDto> {
        let url_ = this.baseUrl + "/api/Users/requestPasswordChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_RequestPasswordChange(_response), options_);
        });
    }

  
    protected processUsers_RequestPasswordChange(response: Response): Promise<RequestPasswordResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestPasswordResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestPasswordResultDto>(null as any);
    }

    users_RegisterClient(command: RegisterUserCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/register/client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_RegisterClient(_response), options_);
        });
    }

 protected processUsers_RegisterClient(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

 users_RegisterBrokerClient(command: RegisterUserCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/register/client/broker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_RegisterBrokerClient(_response), options_);
        });
    }
     protected processUsers_RegisterBrokerClient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 204) {
            return Promise.resolve<void>(null as any);
        } else {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
    }
    users_RegisterBroker(command: RegisterUserCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/register/broker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_RegisterBroker(_response), options_);
        });
    }

    protected processUsers_RegisterBroker(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    users_Accounts(query: FindAllAccountsQuery): Promise<UserAccountDto[]> {
        let url_ = this.baseUrl + "/api/Users/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_Accounts(_response), options_);
        });
    }

    protected processUsers_Accounts(response: Response): Promise<UserAccountDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAccountDto[]>(null as any);
    }

    users_RegisterAdviser(command: RegisterAdviserCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/register/adviser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_RegisterAdviser(_response), options_);
        });
    }

    protected processUsers_RegisterAdviser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    users_RefreshAuthToken(command: RefreshTokenCommand): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users/authenticate/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsers_RefreshAuthToken(_response), options_);
        });
    }

    protected processUsers_RefreshAuthToken(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    mvcUsers_Authenticate(command: AuthenticateMvcUserCommand): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/MvcUsers/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMvcUsers_Authenticate(_response), options_);
        });
    }

    protected processMvcUsers_Authenticate(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

/** A Basic Request via the Mediator */
export abstract class _BaseRequest implements I_BaseRequest {

    constructor(data?: I_BaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): _BaseRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class '_BaseRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** A Basic Request via the Mediator */
export interface I_BaseRequest {
}

export class CreateRoleCommand extends _BaseRequest implements ICreateRoleCommand {
    name!: string | undefined;

    constructor(data?: ICreateRoleCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateRoleCommand extends I_BaseRequest {
    name: string | undefined;
}

export class AddUserToRoleCommand extends _BaseRequest implements IAddUserToRoleCommand {
    userId!: string | undefined;
    roleName!: string | undefined;

    constructor(data?: IAddUserToRoleCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): AddUserToRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserToRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleName"] = this.roleName;
        super.toJSON(data);
        return data;
    }
}

export interface IAddUserToRoleCommand extends I_BaseRequest {
    userId: string | undefined;
    roleName: string | undefined;
}

export class RoleDto implements IRoleDto {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRoleDto {
    id: string | undefined;
    name: string | undefined;
}

export abstract class _BaseRequestOfListOfRoleDto implements I_BaseRequestOfListOfRoleDto {

    constructor(data?: I_BaseRequestOfListOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): _BaseRequestOfListOfRoleDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class '_BaseRequestOfListOfRoleDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface I_BaseRequestOfListOfRoleDto {
}

export class FindAllRolesQuery extends _BaseRequestOfListOfRoleDto implements IFindAllRolesQuery {

    constructor(data?: IFindAllRolesQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): FindAllRolesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FindAllRolesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFindAllRolesQuery extends I_BaseRequestOfListOfRoleDto {
}

export class FindUserRolesQuery extends _BaseRequestOfListOfRoleDto implements IFindUserRolesQuery {

    constructor(data?: IFindUserRolesQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): FindUserRolesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FindUserRolesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFindUserRolesQuery extends I_BaseRequestOfListOfRoleDto {
}

export class UserDto implements IUserDto {
    id!: string | undefined;
    profileId!: number;
    username!: string | undefined;
    clientDatabaseId!: number;
    token!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpiryDate!: string;
    userType!: UserType;
    isTermsAccept!: boolean;
    twoFactorEnabled!: boolean;
    fK_ClientSelectorID!: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.profileId = _data["profileId"];
            this.username = _data["username"];
            this.clientDatabaseId = _data["clientDatabaseId"];
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiryDate = _data["refreshTokenExpiryDate"];
            this.userType = _data["userType"];
            this.isTermsAccept = _data["isTermsAccept"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.fK_ClientSelectorID = _data["fK_ClientSelectorID"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileId"] = this.profileId;
        data["username"] = this.username;
        data["clientDatabaseId"] = this.clientDatabaseId;
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiryDate"] = this.refreshTokenExpiryDate;
        data["userType"] = this.userType;
        data["isTermsAccept"] = this.isTermsAccept;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["fK_ClientSelectorID"] = this.fK_ClientSelectorID;
        return data;
    }
}

export interface IUserDto {
    id: string | undefined;
    profileId: number;
    username: string | undefined;
    clientDatabaseId: number;
    token: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpiryDate: string;
    userType: UserType;
    isTermsAccept: boolean;
    twoFactorEnabled: boolean;
    fK_ClientSelectorID: number;
}

export enum UserType {
    Admin = 0,
    Contact = 1,
    ContactOwner = 2,
    ExternalBroker = 3,
    BrokerContact = 4,
}

export abstract class _BaseRequestOfUserDto implements I_BaseRequestOfUserDto {

    constructor(data?: I_BaseRequestOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): _BaseRequestOfUserDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class '_BaseRequestOfUserDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface I_BaseRequestOfUserDto {
}

export class AuthenticateUserCommand extends _BaseRequestOfUserDto implements IAuthenticateUserCommand {
    username!: string | undefined;
    password!: string | undefined;
    databaseId!: number | undefined;

    constructor(data?: IAuthenticateUserCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.databaseId = _data["databaseId"];
        }
    }

    static fromJS(data: any): AuthenticateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["databaseId"] = this.databaseId;
        super.toJSON(data);
        return data;
    }
}
export class ConfirmTermsAndServiceCommand extends _BaseRequestOfUserDto implements IConfirmTermsAndServiceCommand {
    username!: string | undefined;
    terms!: boolean | undefined;


    constructor(data?: IConfirmTermsAndServiceCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.terms = _data["terms"];
          }
    }

    static fromJS(data: any): ConfirmTermsAndServiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmTermsAndServiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["terms"] = this.terms;
         super.toJSON(data);
        return data;
    }
}

export interface IAuthenticateUserCommand extends I_BaseRequestOfUserDto {
    username: string | undefined;
    password: string | undefined;
    databaseId: number | undefined;
}
export interface IConfirmTermsAndServiceCommand extends I_BaseRequestOfUserDto {
    username: string | undefined;
    terms: boolean | undefined;
    
}

export class ChangeUserPasswordCommand extends _BaseRequest implements IChangeUserPasswordCommand {
    userId!: string | undefined;
    token!: string | undefined;
    password!: string | undefined;

    constructor(data?: IChangeUserPasswordCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["password"] = this.password;
        super.toJSON(data);
        return data;
    }
}

export interface IChangeUserPasswordCommand extends I_BaseRequest {
    userId: string | undefined;
    token: string | undefined;
    password: string | undefined;
}

export class EmailConfirmationResultDto implements IEmailConfirmationResultDto {
    success!: boolean;
    token!: string | undefined;
    expired!: boolean;
    alreadyConfirmed!: boolean;

    constructor(data?: IEmailConfirmationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.token = _data["token"];
            this.expired = _data["expired"];
            this.alreadyConfirmed = _data["alreadyConfirmed"];
        }
    }

    static fromJS(data: any): EmailConfirmationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailConfirmationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["token"] = this.token;
        data["expired"] = this.expired;
        data["alreadyConfirmed"] = this.alreadyConfirmed;
        return data;
    }
}

export interface IEmailConfirmationResultDto {
    success: boolean;
    token: string | undefined;
    expired: boolean;
    alreadyConfirmed: boolean;
}

export class RequestPasswordResultDto implements IRequestPasswordResultDto {
    success!: boolean;
    
    constructor(data?: IRequestPasswordResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
           
        }
    }

    static fromJS(data: any): RequestPasswordResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IRequestPasswordResultDto {
    success: boolean;
   }

   
export class RequestPasswordChangeCommand extends _BaseRequest implements IRequestPasswordChangeCommand {
    email!: string | undefined;
    companyName!: string | undefined;

    constructor(data?: IRequestPasswordChangeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): RequestPasswordChangeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordChangeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["companyName"] = this.companyName;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestPasswordChangeCommand extends I_BaseRequest {
    email: string | undefined;
    companyName: string | undefined;
}

export abstract class _BaseRequestOfString implements I_BaseRequestOfString {

    constructor(data?: I_BaseRequestOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): _BaseRequestOfString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class '_BaseRequestOfString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface I_BaseRequestOfString {
}

export class RegisterUserCommand extends _BaseRequestOfString implements IRegisterUserCommand {
    firstName!: string | undefined;
    lastName!: string | undefined;
    username!: string | undefined;
    password!: string | undefined;
    profileId!: number;
    userType!: UserType;
    contactOwnerId!: number;
    clientDatabaseId!: number;
    sendConfirmationEmail!: boolean;

    constructor(data?: IRegisterUserCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.profileId = _data["profileId"];
            this.userType = _data["userType"];
            this.contactOwnerId = _data["contactOwnerId"];
            this.clientDatabaseId = _data["clientDatabaseId"];
            this.sendConfirmationEmail = _data["sendConfirmationEmail"];
        }
    }

    static fromJS(data: any): RegisterUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["username"] = this.username;
        data["password"] = this.password;
        data["profileId"] = this.profileId;
        data["userType"] = this.userType;
        data["contactOwnerId"] = this.contactOwnerId;
        data["clientDatabaseId"] = this.clientDatabaseId;
        data["sendConfirmationEmail"] = this.sendConfirmationEmail;
        super.toJSON(data);
        return data;
    }
}

export interface IRegisterUserCommand extends I_BaseRequestOfString {
    firstName: string | undefined;
    lastName: string | undefined;
    username: string | undefined;
    password: string | undefined;
    profileId: number;
    userType: UserType;
    contactOwnerId: number;
    clientDatabaseId: number;
    sendConfirmationEmail: boolean;
}

export class UserAccountDto implements IUserAccountDto {
    id!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    username!: string | undefined;
    profileId!: number;
    databaseName!: string | undefined;
    type!: string | undefined;
    emailConfirmed!: string | undefined;
    lockedOutEnabled!: string | undefined;

    constructor(data?: IUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.username = _data["username"];
            this.profileId = _data["profileId"];
            this.databaseName = _data["databaseName"];
            this.type = _data["type"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.lockedOutEnabled = _data["lockedOutEnabled"];
        }
    }

    static fromJS(data: any): UserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["username"] = this.username;
        data["profileId"] = this.profileId;
        data["databaseName"] = this.databaseName;
        data["type"] = this.type;
        data["emailConfirmed"] = this.emailConfirmed;
        data["lockedOutEnabled"] = this.lockedOutEnabled;
        return data;
    }
}

export interface IUserAccountDto {
    id: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    username: string | undefined;
    profileId: number;
    databaseName: string | undefined;
    type: string | undefined;
    emailConfirmed: string | undefined;
    lockedOutEnabled: string | undefined;
}

export abstract class _BaseRequestOfListOfUserAccountDto implements I_BaseRequestOfListOfUserAccountDto {

    constructor(data?: I_BaseRequestOfListOfUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): _BaseRequestOfListOfUserAccountDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class '_BaseRequestOfListOfUserAccountDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface I_BaseRequestOfListOfUserAccountDto {
}

export class FindAllAccountsQuery extends _BaseRequestOfListOfUserAccountDto implements IFindAllAccountsQuery {

    constructor(data?: IFindAllAccountsQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): FindAllAccountsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FindAllAccountsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFindAllAccountsQuery extends I_BaseRequestOfListOfUserAccountDto {
}

export class RegisterAdviserCommand extends _BaseRequest implements IRegisterAdviserCommand {
    username!: string | undefined;
    password!: string | undefined;
    email!: string | undefined;
    profileId!: number;
    clientDatabaseName!: string | undefined;

    constructor(data?: IRegisterAdviserCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.profileId = _data["profileId"];
            this.clientDatabaseName = _data["clientDatabaseName"];
        }
    }

    static fromJS(data: any): RegisterAdviserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAdviserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["email"] = this.email;
        data["profileId"] = this.profileId;
        data["clientDatabaseName"] = this.clientDatabaseName;
        super.toJSON(data);
        return data;
    }
}

export interface IRegisterAdviserCommand extends I_BaseRequest {
    username: string | undefined;
    password: string | undefined;
    email: string | undefined;
    profileId: number;
    clientDatabaseName: string | undefined;
}

export class RefreshTokenCommand extends _BaseRequestOfUserDto implements IRefreshTokenCommand {
    jwt!: string | undefined;
    refreshToken!: string | undefined;

    constructor(data?: IRefreshTokenCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jwt = _data["jwt"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jwt"] = this.jwt;
        data["refreshToken"] = this.refreshToken;
        super.toJSON(data);
        return data;
    }
}

export interface IRefreshTokenCommand extends I_BaseRequestOfUserDto {
    jwt: string | undefined;
    refreshToken: string | undefined;
}

export class AuthenticateMvcUserCommand extends AuthenticateUserCommand implements IAuthenticateMvcUserCommand {
    mvcAuthKey!: string | undefined;

    constructor(data?: IAuthenticateMvcUserCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mvcAuthKey = _data["mvcAuthKey"];
        }
    }

    static fromJS(data: any): AuthenticateMvcUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateMvcUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mvcAuthKey"] = this.mvcAuthKey;
        super.toJSON(data);
        return data;
    }
}

export interface IAuthenticateMvcUserCommand extends IAuthenticateUserCommand {
    mvcAuthKey: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}